import React from 'react';
// import { Select } from 'chakra-react-select';
import {
  Text,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';

import { useTranslation } from 'react-i18next';

const LangSelect = ({
  languages,
  activeLang,
  onActiveLangChange,
}) => {
  const { t } = useTranslation();

  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        variant="ghost"
        size="sm"
        height="24px"
        width={activeLang?.label ? "48px" : 'auto'}
        px={1}
      >
        <Text fontWeight={600}>
          {activeLang?.label || t('Select language...')}
        </Text>
      </MenuButton>
      <MenuList>
        {languages.map((lang) => (
          <MenuItem onClick={() => onActiveLangChange(lang)}>
            {lang?.label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default LangSelect;
